/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cart_Claim_ActiveInputs */

const en_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim`)
};

const ar_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطالبة`)
};

const de_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einsammeln`)
};

const es_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamar`)
};

const fr_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamer`)
};

const it_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscatta`)
};

const ja_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受け取る`)
};

const ko_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`받기`)
};

const pt_br_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reivindicar`)
};

const ru_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить`)
};

const th_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับ`)
};

const tr_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al`)
};

const zh_cn_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`领取`)
};

const zh_tw_cart_claim_active = /** @type {(inputs: Cart_Claim_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`領取`)
};

/**
* | output |
* | --- |
* | "Claim" |
*
* @param {Cart_Claim_ActiveInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cart_claim_active = /** @type {((inputs?: Cart_Claim_ActiveInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cart_Claim_ActiveInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cart_claim_active(inputs)
	if (locale === "ar") return ar_cart_claim_active(inputs)
	if (locale === "de") return de_cart_claim_active(inputs)
	if (locale === "es") return es_cart_claim_active(inputs)
	if (locale === "fr") return fr_cart_claim_active(inputs)
	if (locale === "it") return it_cart_claim_active(inputs)
	if (locale === "ja") return ja_cart_claim_active(inputs)
	if (locale === "ko") return ko_cart_claim_active(inputs)
	if (locale === "pt_br") return pt_br_cart_claim_active(inputs)
	if (locale === "ru") return ru_cart_claim_active(inputs)
	if (locale === "th") return th_cart_claim_active(inputs)
	if (locale === "tr") return tr_cart_claim_active(inputs)
	if (locale === "zh_cn") return zh_cn_cart_claim_active(inputs)
	return zh_tw_cart_claim_active(inputs)
});